import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false,
    cache:false
};

export default {
    path: '/hrm/',
    name: 'hrm',
    noCacheMeta,
    component: BasicLayout,
    children: [
        //kaac
        {
            path: '/hrm/CertificateManagementOverview',
            name: 'CertificateManagementOverview',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.zsglyl',
                desc: '证书安装&更新',
            },
            component: () => import('@/pages/ca/CertificateManagementOverview')
        },
        {
            path: '/hrm/certificateapplication',
            name: 'certificateapplication',
            meta: {
                ...noCacheMeta,
                title: '证书申请',
                desc: '证书申请',
            },
            component: () => import('@/pages/ca/certificateapplication')
        },
        {
            path: '/hrm/DownloadtheP-typecertificate',
            name: 'DownloadtheP-typecertificate',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.P12lxzsxz',
                desc: '管理员证书管理',
            },
            component: () => import('@/pages/ca/DownloadtheP-typecertificate')
        },
        {
            path: '/hrm/caSysCategory',
            name: 'caSysCategory',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.sysCategoryManage',
                desc: '系统分类管理',
            },
            component: () => import('@/pages/ca/sysCategory/caSysCategoryMatchList.vue')
        },
        {
            path: '/hrm/productNumberTable',
            name: 'productNumberTable',
            meta: {
                ...noCacheMeta,
                title: '工序变更申请书',
                desc: '工序变更申请书',
            },
            component: () => import('@/pages/pcn/pcnChangeOfProcessForm.vue')
        },
        {
            path: '/hrm/pcnRecordTable',
            name: 'PcnRecordTable',
            meta: {
                ...noCacheMeta,
                title: 'PCN申请记录一览',
                desc: 'PCN申请记录',
            },
            component: () => import('@/pages/pcn/pcnRecordTable.vue')
        },
        {
            path: '/hrm/pcnStatisticalSummary',
            name: 'pcnStatisticalSummary.vue',
            meta: {
                ...noCacheMeta,
                title: 'PCN申请记录一览',
                desc: 'PCN申请记录',
            },
            component: () => import('@/pages/pcn/pcnStatisticalSummary.vue')
        },
        {
            path: '/hrm/pcnSysEmailConfig',
            name: 'pcnSysEmailConfig.vue',
            meta: {
                ...noCacheMeta,
                title: '工序变更邮件模板管理',
                desc: '邮件模板管理',
            },
            component: () => import('@/pages/pcn/pcnSysEmailConfig.vue')
        },
        {
            path: '/hrm/systemLogs',
            name: 'systemLogs',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.systemLog',
                desc: '系统异常日志',
            },
            component: () => import('@/pages/ca/log/systemLogList.vue')
        },
        {
            path: '/hrm/systemLogsEdit',
            name: 'systemLogsEdit',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.systemLog',
                desc: '系统异常详情',
            },
            component: () => import('@/pages/ca/log/systemLogEdit.vue')
        },
        {
            path: '/hrm/hrOrgTree',
            name: 'hrOrgTree',
            meta: {
                ...noCacheMeta,
                title: 'hr机构树',
                desc: 'hr机构树',
            },
            component: () => import('@/pages/ca/hrOrgTree.vue')
        },
        {
            path: '/hrm/caSysConfig',
            name: 'caSysConfig',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.caSysConfig',
                desc: '系统配置',
            },
            component: () => import('@/pages/ca/caSysConfig.vue')
        },
        {
            path: '/hrm/userAgentCompany',
            name: 'userAgentCompany',
            meta: {
                ...noCacheMeta,
                title: '$t:komatsu.caCert.btn.user_cert_agent_apply',
                desc: '用户-可代理申请的公司or代理店权限',
            },
            component: () => import('@/pages/ca/userAgentCompany.vue')
        },
        {
            path: '/hrm/ldapTree',
            name: 'ldapTree',
            meta: {
                ...noCacheMeta,
                title: 'ldapTree',
                desc: 'ldapTree',
            },
            component: () => import('@/pages/ca/ldapTree.vue')
        },
        {
            path: '/hrm/test',
            name: 'test',
            meta: {
                ...noCacheMeta,
                title: 'test',
                desc: 'test',
            },
            component: () => import('@/pages/ca/test.vue')
        }
    ]
}
